import { DiContainerInjectFn } from '@@/di/ts';
import { BagsService } from '@@/bags/services/bags.service';

export default ((container) => {
  container.bind(BagsService).to(BagsService).inSingletonScope();
}) as DiContainerInjectFn;
